module.exports = __webpack_public_path__ + "img/banner3.d1a20722.png";